import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LikeComponent } from '@app/shared/components/like/like.component';
import { SvgModule } from '../svg/svg.module';

@NgModule({
  imports: [CommonModule, SvgModule],
  exports: [LikeComponent],
  declarations: [LikeComponent]
})
export class LikeModule {}
